import React, { useContext, useRef } from 'react';
import { change, Field } from 'redux-form';
import AutocompleteSelectField from 'chameleon/ui-stack/ui/forms/autocomplete-select-field';
import Context from '../../Context';
import FieldWrapper from '../fields/FieldWrapper';
import { FIELD_META_MAP } from '../../utils/constants';
import { getFieldOption, getAlignText } from '../../utils';
import SectionsDropdown from '../../sections/SectionsDropdown';
import { connect } from 'react-redux';

const CommonOptions = ({ reviewMode }) => {
  const {
    printToggle,
    printSelectDisabled,
    showFormatOption,
    dueAt,
    isPilot,
    isSPP,
    scoreDisplay,
    timer,
    hiddenClass,
    isAdminOrCoordinator,
    individualStudentAssignmentFlag,
    isAssign,
    startsAtError,
    isResourceForm,
    isAssessmentForm,
    dispatch,
    hasForcedScrambledOrder,
  } = useContext(Context);
  const manageSettingsDetailsRef = useRef(null);

  const manageSettingsClassesHelpText = useRef(
    FIELD_META_MAP.SECTIONS.detailsComponent({
      isAssign,
      individualStudentAssignmentFlag,
    }),
  );

  const startsAtErrorText = startsAtError
    ? typeof startsAtError === 'string'
      ? startsAtError
      : startsAtError[0]
    : null;

  const onPrintToggleChange = (form) => {
    dispatch(change(form, 'isSecure', false));
  };

  const optionContainerRef = useRef();

  return (
    <div className="ft-amf-assignment-options-container">
      <div className="ft-amf-option-container" ref={optionContainerRef}>
        <FieldWrapper field={FIELD_META_MAP.SECTIONS}>
          <SectionsDropdown
            assigneesName="assignees"
            updateAssigneesName="updateAssignees"
            allAssigneesName="allAssignees"
            isAdminOrCoordinator={isAdminOrCoordinator}
            optionContainerRef={optionContainerRef}
          />
        </FieldWrapper>
        {isAssessmentForm &&
          (manageSettingsClassesHelpText.current ? (
            <div
              className="ft-amf-option-details"
              ref={manageSettingsDetailsRef}
            >
              {manageSettingsClassesHelpText.current}
            </div>
          ) : (
            !!startsAtErrorText && (
              <div className="ft-amf-option-details visuallyhidden">
                {getAlignText(startsAtErrorText)}
              </div>
            )
          ))}
      </div>
      {showFormatOption && (
        <div
          className="ft-amf-option-container"
          data-test-id={FIELD_META_MAP.FORMAT.dataTestId}
        >
          <FieldWrapper field={FIELD_META_MAP.FORMAT}>
            <Field
              name="printToggle"
              component={AutocompleteSelectField}
              props={{
                className: 'ft-amf-select-root',
                portalContainerClassName: 'z-overModals',
                options: FIELD_META_MAP.FORMAT.options,
                value: getFieldOption(FIELD_META_MAP.FORMAT, printToggle),
                placeholder: {
                  label: FIELD_META_MAP.FORMAT.placeholder,
                },
                disableDropdown: printSelectDisabled,
                onChange: onPrintToggleChange,
              }}
            />
          </FieldWrapper>
          <div
            aria-live="polite"
            className="ft-amf-option-details text-gray-600"
          >
            {hasForcedScrambledOrder &&
              FIELD_META_MAP.FORMAT.detailsComponent()}
          </div>
          {!!dueAt && !isResourceForm && (
            <div className="ft-amf-option-details visuallyhidden">
              {getAlignText(FIELD_META_MAP.DUE_DATE.detailsComponent())}
            </div>
          )}
        </div>
      )}
      {isAssessmentForm && !isSPP && !isPilot && (
        <div
          className="ft-amf-option-container"
          data-test-id={FIELD_META_MAP.STUDENT_RESULTS.dataTestId}
        >
          <FieldWrapper field={FIELD_META_MAP.STUDENT_RESULTS}>
            <Field
              name="scoreDisplay"
              component={AutocompleteSelectField}
              props={{
                className: 'ft-amf-select-root',
                portalContainerClassName: 'z-overModals',
                options: FIELD_META_MAP.STUDENT_RESULTS.options(reviewMode),
                value: getFieldOption(
                  FIELD_META_MAP.STUDENT_RESULTS,
                  scoreDisplay,
                  reviewMode,
                ),
                placeholder: {
                  label: FIELD_META_MAP.STUDENT_RESULTS.placeholder,
                },
                disableDropdown: false,
              }}
            />
          </FieldWrapper>
          {!!timer && (
            <div className={hiddenClass}>
              {getAlignText(FIELD_META_MAP.TIMER.detailsComponent())}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

CommonOptions.displayName = 'CommonOptions';

export default connect((state) => ({
  reviewMode: state.featureFlag.review_mode,
}))(CommonOptions);
